export default __webpack_public_path__ + "locales/ar-SA/EmptyTrashDialog.json?hash=cf0cc3dcb37d421a72b9f8e7ef99b513";